import React, { Component } from 'react'

export default class IconSmallPlus extends Component {
  render() {
    return (
      <svg
        width="17"
        height="17"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g
          stroke="#FFF"
          fill="none"
          fillRule="evenodd"
          strokeLinecap="square"
        >
          <path d="M8 1v15M1 9h15"/>
        </g>
      </svg>
    )
  }
}



// WEBPACK FOOTER //
// ./src/ui/components/generic/IconSmallPlus.js